import React from 'react'
import { useInView } from 'react-intersection-observer'

import { Container } from '../components/Container'
import { Heading } from '../components/Heading'
import { Section } from '../components/Section'
import { LinkButton } from '../components/LinkButton'
import { StaticImage } from 'gatsby-plugin-image'
import { twMerge } from 'tailwind-merge'

interface LearningKidsFinanceProps {}

export const LearningKidsFinance = ({}: LearningKidsFinanceProps) => {
  const { ref, inView } = useInView({
    /* Optional options */
    threshold: 0.5,
  })
  const _className = twMerge(
    'py-8 xl:py-12 transform duration-1000 ease-out will-change-transform transition-all translate-y-12 opacity-0',
    inView ? 'translate-y-0 opacity-100' : '',
  )

  return (
    <Section ref={ref} className={_className}>
      <Container>
        <div className="grid gap-8 items-center lg:grid-cols-[1fr,auto] bg-secondary-50 rounded">
          <div className="grid p-6 pb-0 md:p-8 lg:pr-0 gap-4">
            <Heading as="h2" className="max-lg:text-3xl lg:leading-snug">
              Učíme děti být
              <br />
              finančně gramotní
            </Heading>

            <p className="leading-loose">
              Založili jsme neziskovou organizaci, zabývající se vzděláváním
              dětí v oblasti finanční gramotnosti.
            </p>
          </div>

          <div className="grid max-md:gap-4 grid-cols-[auto,1fr] md:grid-cols-[auto,auto] lg:pt-4 place-items-end justify-center justify-items-center">
            <StaticImage
              src="../images/neziskovka.png"
              alt="Neziskovka"
              objectFit="contain"
              className="max-sm:max-w-[140px] max-sm:ml-4 sm:w-[240px]"
            />

            <div className="grid gap-8 h-full p-6 pt-0 md:p-8 pl-0 items-center justify-center justify-items-center">
              <StaticImage
                src="../images/neziskovka-logo.png"
                alt="Neziskovka"
                objectFit="contain"
                className="max-md:max-w-[170px] md:w-[240px] h-auto object-contain"
              />

              <LinkButton
                className="button--secondary"
                href="/blog/ucime-deti-financni-gramotnost"
              >
                Jak fungujeme
              </LinkButton>
            </div>
          </div>
        </div>
      </Container>
    </Section>
  )
}
